{
	"name": "top-golf-payment",
	"version": "0.0.302",
	"author": "Sterlix GmbH",
	"homepage": "https://smoothr.de/",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"build": "ng build",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"lint": "ng lint",
		"prepare": "husky",
		"postbuild": "",
		"deploy:dev": "~/bin/devEnv && ng build && gsutil -m rsync -R ./www/browser gs://dev-topgolf.smoothr.de && gcloud compute url-maps invalidate-cdn-cache dev-topgolf-https --path \"/*\" --global",
		"deploy:prod": "~/bin/prodEnv && ng build --configuration production && gsutil -m rsync -R ./www/browser gs://topgolf.smoothr.de && gcloud compute url-maps invalidate-cdn-cache topgolf-https --path \"/*\" --global",
		"prettier": "prettier --write '**/*.{ts,js,css,html}'",
		"sentry:sourcemaps": "sentry-cli sourcemaps inject --org smoothr --project topgolf-payment-app ./www && sentry-cli --url https://logs.smoothr.de sourcemaps upload --org smoothr --project topgolf-payment-app ./www"
	},
	"private": true,
	"dependencies": {
		"@adyen/adyen-web": "^6.31.1",
		"@angular/animations": "^21.2.0",
		"@angular/common": "^21.2.0",
		"@angular/compiler": "^21.2.0",
		"@angular/core": "^21.2.0",
		"@angular/forms": "^21.2.0",
		"@angular/platform-browser": "^21.2.0",
		"@angular/platform-browser-dynamic": "^21.2.0",
		"@angular/router": "^21.2.0",
		"@capacitor/app": "7.1.0",
		"@capacitor/core": "7.4.3",
		"@capacitor/haptics": "7.0.2",
		"@capacitor/keyboard": "7.0.3",
		"@capacitor/status-bar": "7.0.3",
		"@ionic/angular": "^8.7.18",
		"@ionic/angular-server": "^8.7.18",
		"@microsoft/clarity": "^1.0.0",
		"@ngx-translate/core": "^17.0.0",
		"@ngx-translate/http-loader": "^17.0.0",
		"@sentry/angular": "^10.23.0",
		"@sentry/cli": "^2.57.0",
		"@zxing/browser": "^0.1.5",
		"@zxing/library": "^0.21.3",
		"@zxing/ngx-scanner": "^21.0.0",
		"angularx-qrcode": "^21.0.4",
		"dayjs": "^1.11.18",
		"fflate": "^0.8.2",
		"ionicons": "^7.0.0",
		"rxjs": "~7.8.0",
		"socket.io-client": "^4.8.1",
		"tslib": "^2.3.0",
		"validator": "^13.15.15",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-eslint/builder": "^21.2.0",
		"@angular-eslint/eslint-plugin": "^21.2.0",
		"@angular-eslint/eslint-plugin-template": "^21.2.0",
		"@angular-eslint/schematics": "^21.2.0",
		"@angular-eslint/template-parser": "^21.2.0",
		"@angular/build": "^21.2.0",
		"@angular/cli": "^21.2.0",
		"@angular/compiler-cli": "^21.2.0",
		"@angular/language-service": "^21.2.0",
		"@capacitor/cli": "7.4.3",
		"@ionic/angular-toolkit": "^11.0.1",
		"@types/jasmine": "~5.1.0",
		"@types/node": "^24.5.2",
		"@types/validator": "^13.15.3",
		"@typescript-eslint/eslint-plugin": "^8.18.0",
		"@typescript-eslint/parser": "^8.18.0",
		"eslint": "^9.16.0",
		"eslint-plugin-import": "^2.29.1",
		"eslint-plugin-jsdoc": "^48.2.1",
		"eslint-plugin-prefer-arrow": "1.2.2",
		"husky": "^9.1.7",
		"jasmine-core": "~5.1.0",
		"jasmine-spec-reporter": "~5.0.0",
		"karma": "~6.4.0",
		"karma-chrome-launcher": "~3.2.0",
		"karma-coverage": "~2.2.0",
		"karma-jasmine": "~5.1.0",
		"karma-jasmine-html-reporter": "~2.1.0",
		"prettier": "3.6.2",
		"typescript": "~5.9.3"
	},
	"prettier": {
		"tabWidth": 4,
		"useTabs": true,
		"singleQuote": true,
		"trailingComma": "es5",
		"bracketSpacing": true,
		"arrowParens": "avoid",
		"printWidth": 140,
		"semi": true,
		"endOfLine": "lf"
	},
	"description": ""
}
